import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { ISplitRequest, ISplitResponse } from '../../api/types';

/**
 * Splits a parent document into child documents. On success the documents
 * manifest is invalidated so the parent (excluded server-side) drops out and
 * the new children appear when the list is next viewed.
 *
 * The backend endpoint is still being built in glynt-api (TDD); the request
 * contract is final, so this hook is safe to wire and unit-test ahead of
 * deployment.
 */
export default function useSplitDocument(dpid: string, documentId: string) {
  const glynt = useGlynt(dpid);
  const queryClient = useQueryClient();

  return useMutation<ISplitResponse, Error, ISplitRequest>({
    mutationFn: async (body: ISplitRequest) =>
      (await glynt).document.splitDocument(documentId, body),
    onSuccess: () => {
      // The manifest query key is ['documents', { ...filters }] — invalidate
      // the whole family so every paginated/filtered view refetches.
      queryClient.invalidateQueries({ queryKey: ['documents'] });
    },
  });
}
